var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRrelply = function SvgIconRrelply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9DA0A3",
    d: "M1 0v13h13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9DA0A3",
    d: "m10 9 4 4-4 4"
  })));
};
export default SvgIconRrelply;